import Typography from '@alltrails/core/components/Typography';
import styles from './PageUISummary.module.scss';

type Props = {
  /** Plain text, never HTML. */
  summary: string;
};

/**
 * The agent's summary at the top of a response, for both `llm-summary` and `llm-error-summary`.
 */
export default function PageUISummary({ summary }: Props) {
  return (
    <Typography className={styles.summary} component="p" variant="paragraph200">
      {summary}
    </Typography>
  );
}
